import type { TMessages } from '@/types/TMessages'

export const messages = {
  buttons: {
    close: 'Понятно',
  },
  text: {
    title: 'Что-то пошло не так',
    description: 'Попробуйте отправить форму позже',
  },
} satisfies TMessages
